<template>
    <div id="ESI">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../static/images/zhtsgbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'ESI数据开放服务系统'" ></detailBread>
        <div class="ESIbox">
            <h3>ESI数据开放服务系统</h3>
            <p>实现高校ESI学科数据的导入、处理、规范、集成与分析，建立适用于ESI院系级服务的数据标准规范，实现基于时间序列的ESI学科数据状态管理和本地化存储，全力保障“学术影响力提升计划”的推进实施，学科建设提供全方位的数据支撑服务</p>
            <div class="img1box">
                <img src="../../static/images/ESI1.png" style="width:1056px;height:384px"/>
            </div>
            <div class="img2box">
                <img src="../../static/images/ESI2.png" style="width:1067px;height:626px"/>
            </div>
             <div class="img3box">
                <img src="../../static/images/ESI3.png" style="width:1068px;height:543px"/>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: 'ESI数据开放服务系统', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: 'ESI数据开放服务系统'
        },
        {
            name: 'description',
            content: 'ESI数据开放服务系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'2',
            blackTabsNum:'0'
        }
    },
    methods: {
        topback(){
            window.localStorage.setItem('blackTabsNum',0)
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
/* @import url('../assets/css/old/reset.css');
@import url('../assets/css/old/all.css'); */
</style>


// WEBPACK FOOTER //
// src/pages/ESI.vue